import script from "./ListaDoCatalogo.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaDoCatalogo.vue?vue&type=script&setup=true&lang=js"

import "./ListaDoCatalogo.vue?vue&type=style&index=0&id=7f095e40&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f095e40"]])

export default __exports__